export default __webpack_public_path__ + "static/im_bg_cta_768-990d582570d512d06fac0443fc0b8c3f.png";